export default function (Component) {
  Component.__i18n = Component.__i18n || []
  Component.__i18n.push({
    "locale": "en",
    "resource": {
      "Back to homepage": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Back to homepage"])}
    }
  })
}
